module.exports = require('./helpers/bundle-url').getBundleURL('IQ6Sv') + "logo-dark.a922e36b.svg";